import { CommonModule } from '@angular/common';
import { Component, effect, Input } from '@angular/core';
import { STATE_MAP, COUNTRY_MAP } from 'app/constants/location-constants';
import { DataEmptyAnimationComponent } from '../../animations/data-animations/data-empty-state/data-empty-animation.component';
import { SvgLoaderComponent } from 'app/components/ui-kit/images/svg-loader/svg-loader.component';
import { DeviceService } from 'app/services/device.service';
import { AppStateService } from 'app/services/app-state.service';

@Component({
  selector: 'app-flight-location',
  standalone: true,
  imports: [CommonModule, DataEmptyAnimationComponent, SvgLoaderComponent],
  templateUrl: './flight-location.component.html',
  styleUrl: './flight-location.component.scss'
})
export class FlightLocationComponent {
  @Input() isPrecise: boolean = false;
  @Input() isDeparture: boolean = false;
  @Input() locationData: any = {};

  locationName: string = null;
  locationLabel: string = null;
  generalIcon: string = null;

  constructor(private deviceService: DeviceService, private appState: AppStateService) {
    effect(() => {
      if (this.appState.agent.currentDataModel()) {
        this.handleLocationData();
      }
    })
  }

  ngOnInit(): void {
    this.handleLocationData();
  }

  handleLocationData() {
    const trimDefaultCountry = (location: string): string =>
      location.endsWith(', US') ? location.replace(/, US$/, '') : location;
  
    if (this.isDeparture) {
      if (this.locationData?.locationName && this.locationData?.airportName) {
        this.locationName = trimDefaultCountry(this.locationData.locationName);
        this.locationLabel = `Departing from ${this.locationData.airportName} (${this.locationData.airportCode || ''})`;
      } else {
        this.locationLabel = 'Where are you leaving from?';
      }
    } else {
      if (this.isPrecise === false) {
        this.handleGeneralLocation();
        return;
      }
  
      if (this.locationData?.locationName && this.locationData?.airportName) {
        this.locationName = trimDefaultCountry(this.locationData.locationName);
        this.locationLabel = `${this.locationData.airportName} (${this.locationData.airportCode || ''})`;
      } else {
        this.locationLabel = 'Where are you headed to?';
      }
    }
  }

  getIconSize() {
    const deviceType = this.deviceService.getDeviceType();
    switch (deviceType) {
      case 'desktop':
        return '32px';
      case 'tablet':
        return '32px';
      case 'mobile':
        return '24px';
      default:
        return '28px';
    }
  }

  handleGeneralLocation() {
    const dest = this.locationData;
    const { destinationType, state, country } = dest;

    if (!destinationType) {
      return;
    }

    this.generalIcon = destinationType.toLowerCase() === 'beach' ? 'beach' : 'mountain';
  
    if (destinationType) {
      let location = `Any ${destinationType} destination`;
  
      const friendlyState = state && STATE_MAP[state.toUpperCase()] || state;
      const friendlyCountry = country && COUNTRY_MAP[country.toUpperCase()] || country;
  
      if (friendlyState && friendlyCountry) {
        location += ` in ${friendlyState}, ${friendlyCountry}`;
      } else if (friendlyState) {
        location += ` in ${friendlyState}`;
      } else if (friendlyCountry) {
        location += ` in ${friendlyCountry}`;
      }
  
      this.locationLabel = location;
    }
  }
  


}
